/* eslint-disable @typescript-eslint/no-explicit-any */
import { ClinicAndFlags } from '@/modules/Auth/auth-types'
import { getCache } from './cache'
import { sendInsiderCustomEvent } from '@/services/insider'

export function crmEvent(
  eventName: string,
  eventProperties?: { [key: string]: any },
): void {
  const clinicAndFlags = getCache<ClinicAndFlags>('clinic')
  if (!clinicAndFlags?.flags?.PermiteEnvioBraze) {
    return
  }

  sendInsiderCustomEvent(eventName, eventProperties)
}
